import { useState, useEffect } from "react";
import { makeStyles } from "@/compat/muiStyles";
import { Typography, Button } from "@mui/material";
import CardBase from "../../components/cards/CardBase";
import { useAuth } from "../../contexts/authContext";
import SeekAdviceDialog from "./dialogs/SeekAdviceDialog";
import { useAppSelector } from "@/redux/hooks";

const useStyles = makeStyles((theme) => ({
    content: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    description: {
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    button: {
        width: "100%",
    },
    cardWrapper: {
        marginBottom: theme.spacing(2)
    }
}));

function SeekAdviceCard() {
    const classes = useStyles();
    const { isSafetyNestSeekAdviceAllowedForSites, user } = useAuth();
    const [open, setOpen] = useState(false);
    const { selectedAccount } =
        useAppSelector((state) => state.account);

    const isSafetyNestSeekAdviceAllowed = isSafetyNestSeekAdviceAllowedForSites;

    if (!isSafetyNestSeekAdviceAllowed) {
        return null;
    }
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <div className={classes.cardWrapper}>
                <CardBase title="Seek Advice">
                    <div className={classes.content}>
                        <Typography variant="body2" className={classes.description}>
                            Need help or guidance? Click the 'Seek Advice' button to get expert support and answers tailored just for you!
                        </Typography>
                        <Button
                            variant="contained"
                            color="inherit"
                            className={classes.button}
                            style={{ backgroundColor: '#5c45c7', color: 'white' }}
                            startIcon={<svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeLarge" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ThreePIcon" aria-label="fontSize large"><path d="M20 2H4.01c-1.1 0-2 .9-2 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-8 4c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m4 8H8v-.57c0-.81.48-1.53 1.22-1.85.85-.37 1.79-.58 2.78-.58s1.93.21 2.78.58c.74.32 1.22 1.04 1.22 1.85z"></path></svg>}
                            onClick={() => setOpen(true)}
                        >
                            Seek Advice
                        </Button>
                    </div>
                </CardBase>
            </div>

            <SeekAdviceDialog
                open={open}
                onClose={handleClose}
                titleText="Seek Advice"
            />
        </>
    );
}

export default SeekAdviceCard; 